import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MerchantService } from '../merchant.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MenusService } from '../../../../../_services/menu.service';
import { AlertService } from '../../../../../_services/alert.service';
import { moreThanOneWhiteSpaceValidator } from 'src/app/common/common.validators';
import { environment } from '../../../../../../environments/environment';
import { ApiHttpService } from '../../../../../_services/api-http.service';
import { DocumentViewerModalComponent } from '../../../../../common/document-viewer-modal.component';
import { debounceTime, distinctUntilChanged, timeout, catchError, of, lastValueFrom } from 'rxjs';

const MIME_BY_EXT: Record<string, string> = {
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  bmp: 'image/bmp',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
};

const { API_URLBLAZE } = environment;

interface DropDownValues {
  FieldValue: number;
  FieldText: string;
}
interface DropDownValuessubc {
  id: number;
  bussinessSubCategories: string;
  bussinessCategories: any;
  riskLevel: any;
  riskLevelCode: any;
  bussinessCategoriesID: any;
}

interface FieldConfig {
  key: string;
  type: 'text' | 'select' | 'date' | 'file' | 'number' | 'percentage';
  label: string;
  required?: boolean;
  placeholder?: string;
  maxlength?: number;
  items?: any[];
  bindLabel?: string;
  bindValue?: string;
  accept?: string;
  documentType?: string;
  extensions?: string[];
  uploadedFileKey?: string;
  readonly?: boolean;
  min?: string;
  max?: string;
  onChange?: (event: any) => void;
  keypress?: (event: any) => boolean;
  preventKeyInput?: boolean;
  multiple?: boolean;
  closeOnSelect?: boolean;
  searchable?: boolean;
  hidden?: boolean;
}

@Component({
  selector: 'app-merchant-add',
  templateUrl: './merchant-add.component.html',
  styleUrls: ['./merchant-add.component.scss'],
})
export class MerchantAddComponent implements OnInit {
  form: FormGroup;
  isSubmitted = false;
  loading = false;
  phoneError = '';
  phoneExists = false;
  checkingPhone = false;
  private hydratingFromServer = false;

  userId: string;
  disableFields = false;
  queryParams: any = {};
  private merchantLookupId: number | null = null;
  private merchantLicenseTypeLookupId: number | null = null;
  private merchantBusinessActivityLookupId: number | null = null;
  public permissions: any = [];
  posEnable = false;
  posEnableLoading = false;
  private getAllData: any;

  currentDate: any = new Date();
  private readonly allowedDocExtensions = [
    'docx', '.pdf','pdf', 'PDF', 'png', 'PNG', 'jpg', 'JPG', 'jpeg', 'JPEG', 'bmp', 'BMP',
  ];
  private readonly allowedPhotoExtensions = [
    'png', 'PNG', 'jpg', 'JPG', 'jpeg', 'JPEG',
  ];
  private readonly regularDocumentKeys = [
    'proofOfAddressFile',
    'selfEmployedCertFile',
    'taxDocumentFile',
    'rcDocumentFile',
    'interiorPhotoFile',
    'exteriorPhotoFile',
    'articlesOfAssociationFile',
  ];
  // Keyed by license_type.id (as a string) - see /user/merchant/license-type. The same 4
  // Self-Employed: 1 (en), 5 = Auto-entrepreneur (fr), 9 = مقاول ذاتي (ar)
  private readonly licenseDocumentTypeMap: { [licenseTypeId: string]: { [key: string]: string } } = {
    '1': {
      proofOfAddressFile: 'AUTO_ADDRESS',
      selfEmployedCertFile: 'AUTO_CERTIFICATE',
    },
    '5': {
      proofOfAddressFile: 'AUTO_ADDRESS',
      selfEmployedCertFile: 'AUTO_CERTIFICATE',
    },
    '9': {
      proofOfAddressFile: 'AUTO_ADDRESS',
      selfEmployedCertFile: 'AUTO_CERTIFICATE',
    },
    '2': {
      taxDocumentFile: 'PATENTE_TAX',
      interiorPhotoFile: 'INDOOR_PHOTO',
      exteriorPhotoFile: 'OUTDOOR_PHOTO',
    },
    '6': {
      taxDocumentFile: 'PATENTE_TAX',
      interiorPhotoFile: 'INDOOR_PHOTO',
      exteriorPhotoFile: 'OUTDOOR_PHOTO',
    },
    '10': {
      taxDocumentFile: 'PATENTE_TAX',
      interiorPhotoFile: 'INDOOR_PHOTO',
      exteriorPhotoFile: 'OUTDOOR_PHOTO',
    },
    '3': {
      rcDocumentFile: 'RC_RC',
      taxDocumentFile: 'RC_TAX',
      interiorPhotoFile: 'INDOOR_PHOTO',
      exteriorPhotoFile: 'OUTDOOR_PHOTO',
      articlesOfAssociationFile: 'BYLAWS',
    },
    '7': {
      rcDocumentFile: 'RC_RC',
      taxDocumentFile: 'RC_TAX',
      interiorPhotoFile: 'INDOOR_PHOTO',
      exteriorPhotoFile: 'OUTDOOR_PHOTO',
      articlesOfAssociationFile: 'BYLAWS',
    },
    '11': {
      rcDocumentFile: 'RC_RC',
      taxDocumentFile: 'RC_TAX',
      interiorPhotoFile: 'INDOOR_PHOTO',
      exteriorPhotoFile: 'OUTDOOR_PHOTO',
      articlesOfAssociationFile: 'BYLAWS',
    },
    '4': {
      rcDocumentFile: 'MORALE_RC',
      taxDocumentFile: 'MORALE_TAX',
      interiorPhotoFile: 'INDOOR_PHOTO',
      exteriorPhotoFile: 'OUTDOOR_PHOTO',
      articlesOfAssociationFile: 'MORALE_STATUS',
    },
    '8': {
      rcDocumentFile: 'MORALE_RC',
      taxDocumentFile: 'MORALE_TAX',
      interiorPhotoFile: 'INDOOR_PHOTO',
      exteriorPhotoFile: 'OUTDOOR_PHOTO',
      articlesOfAssociationFile: 'MORALE_STATUS',
    },
    '12': {
      rcDocumentFile: 'MORALE_RC',
      taxDocumentFile: 'MORALE_TAX',
      interiorPhotoFile: 'INDOOR_PHOTO',
      exteriorPhotoFile: 'OUTDOOR_PHOTO',
      articlesOfAssociationFile: 'MORALE_STATUS',
    },
  };
  uploadedFileNames: { [key: string]: string } = {};

  private applyingLicenseTypeState = false;
  private applyingMerchantTypeState = false;
  private applyingClientProLevelState = false;
  private applyingEntityTypeState = false;

  public nameRegex = /^[A-Za-zÀ-ÿ' -]+$/;

  entityTypeOptions: any[] = [
    { value: 'MERCHANT', text: 'Merchant' },
    { value: 'AGENT', text: 'Agent' },
  ];
  merchantTypeOptions: any[] = [
    { value: 'REGULAR', text: 'Regular Merchant' },
    { value: 'CLIENT_PRO', text: 'Client Pro' },
  ];
  licenseTypeOptions: any[] = [];
  clientProLevelOptions: any[] = [
    { value: 'L1', text: 'L1' },
    { value: 'L2', text: 'L2' },
  ];
  volumeYearlyRangeOptions: any[] = [];

  banksOptions: any[] = [];

  idCardTypeOptions: any[] = [
    { value: 'CIN', text: 'CIN' },
    { value: 'RESIDENCE_PERMIT', text: 'Residence Permit' },
    { value: 'PASSPORT', text: 'Passport' },
  ];

  instrumentMasterOptions: DropDownValues[] = [];
  categoryTypeOptions: any[] = [];
  subCategoryTypeOptions: DropDownValuessubc[] = [];
  businessActivityOptions: any[] = [];
  activityOptions: any[] = [];
  subActivityOptions: any[] = [];
  business_category: any;
  business_subCategory: any;
  riskLevelCode: any;
  riskLevelCode1: any[] = [];

  constructor(
    private alertService: AlertService,
    private menuService: MenusService,
    private location: Location,
    private route: ActivatedRoute,
    private router: Router,
    public formBuilder: FormBuilder,
    private merchantService: MerchantService,
    private apiHttpService: ApiHttpService,
    private http: HttpClient,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
  ) {
    this.form = this.formBuilder.group({
      phoneNumber: [
        '',
        [Validators.required, Validators.pattern(/^(0\d{9}|[1-9]\d{8})$/)],
      ],
      firstName: [
        '',
        [
          Validators.required,
          moreThanOneWhiteSpaceValidator(),
          Validators.pattern(this.nameRegex),
          Validators.maxLength(50),
        ],
      ],
      lastName: [
        '',
        [
          Validators.required,
          moreThanOneWhiteSpaceValidator(),
          Validators.pattern(this.nameRegex),
          Validators.maxLength(50),
        ],
      ],
      userType: ['', Validators.required],
      emailId: [
        '',
        [
          Validators.email,
          Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$'),
        ],
      ],
      address: [
        '',
        [Validators.required, moreThanOneWhiteSpaceValidator(), Validators.maxLength(200)],
      ],
      city: [
        '',
        [Validators.pattern(this.nameRegex), Validators.maxLength(50)],
      ],
      merchantType: [null],
      licenseType: [null],
      companyName: [''],
      clientProLevel: [null],
      businessActivity: [null],
      activity: [null],
      subActivity: [null],
      volumeRange: [null],
      bankName: [null],
      iban: [null],
      pgInstruments: [[]],
      signedContractFile: [null],
      pay10ContractSignedFile: [null],
      regular: this.formBuilder.group({
        numberOfShareholders: [1],
        proofOfAddressFile: [null],
        selfEmployedCertFile: [null],
        taxDocumentFile: [null],
        rcDocumentFile: [null],
        interiorPhotoFile: [null],
        exteriorPhotoFile: [null],
        articlesOfAssociationFile: [null],
      }),
      shareholders: this.formBuilder.array([this.buildShareholderGroup()]),
      clientPro: this.formBuilder.group({
        latitude: [
          '',
          [
            Validators.required,
            Validators.pattern(/^-?([1-8]?[0-9](\.\d+)?|90(\.0+)?)$/),
          ],
        ],
        longitude: [
          '',
          [
            Validators.required,
            Validators.pattern(/^-?((1[0-7][0-9])|([0-9]?[0-9]))(\.\d+)?$|^-?180(\.0+)?$/),
          ],
        ],
        interiorPhotoFile: [null],
        exteriorPhotoFile: [null],
      }),
    });
  }

  get regularGroup(): FormGroup {
    return this.form.get('regular') as FormGroup;
  }

  get clientProGroup(): FormGroup {
    return this.form.get('clientPro') as FormGroup;
  }

  get shareholders(): FormArray {
    return this.form.get('shareholders') as FormArray;
  }

  getShareholderGroup(index: number): FormGroup {
    return this.shareholders.at(index) as FormGroup;
  }

  get isMerchantEntity(): boolean {
    return this.form.get('userType')?.value === 'MERCHANT';
  }

  get isRegularMerchant(): boolean {
    return this.isMerchantEntity && this.form.get('merchantType')?.value === 'REGULAR';
  }

  get isClientPro(): boolean {
    return this.isMerchantEntity && this.form.get('merchantType')?.value === 'CLIENT_PRO';
  }

  get transactionLimit(): number {
    return this.form.get('clientProLevel')?.value === 'L2' ? 4000 : 1000;
  }

  ctrl(group: FormGroup, key: string): AbstractControl {
    return group.get(key) as AbstractControl;
  }

  trackByFieldKey(_index: number, field: FieldConfig): string {
    return field.key;
  }

  private collectInvalidLabels(group: FormGroup, configs: FieldConfig[], prefix = ''): string[] {
    return configs
      .filter((f) => {
        const c = group.get(f.key);
        return !!c && c.enabled && c.invalid;
      })
      .map((f) => prefix + f.label);
  }

  get invalidFieldSummary(): string[] {
    if (!this.form) return [];
    let labels = this.collectInvalidLabels(this.form, this.contactFieldConfigs);
    if (this.isMerchantEntity) {
      labels = labels.concat(this.collectInvalidLabels(this.form, this.merchantCommonFieldConfigs));
      if (this.isRegularMerchant) {
        labels = labels.concat(this.collectInvalidLabels(this.regularGroup, this.licenseDocFieldConfigs));
        this.shareholders.controls.forEach((g, i) => {
          const prefix = this.shareholders.length > 1 ? `Shareholder ${i + 1} - ` : '';
          labels = labels.concat(this.collectInvalidLabels(g as FormGroup, this.shareholderFieldConfigs(i), prefix));
        });
      }
      if (this.isClientPro) {
        labels = labels.concat(this.collectInvalidLabels(this.clientProGroup, this.clientProLocationFieldConfigs));
        labels = labels.concat(this.collectInvalidLabels(this.clientProGroup, this.clientProPhotoFieldConfigs));
      }
    }
    return labels;
  }

  async ngOnInit() {
    this.getBusinessCatigory();
    this.loadActivityDropdown();
    this.instrumentMasterOptions = (await lastValueFrom(this.merchantService.getInstrumentMaster())) || [];
    this.merchantService.getVolumeRanges().subscribe((res: any) => {
      this.volumeYearlyRangeOptions = (res?.response?.data || []).map((vr: any) => ({
        ...vr,
        id: String(vr.id),
      }));
    });

    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);

    this.route.queryParams.subscribe((params) => {
      this.queryParams = params;
      const lookupCandidate = params?.bankCode ?? params?.bank_code ?? params?.id;
      const parsedLookup = Number(lookupCandidate);
      this.merchantLookupId = Number.isFinite(parsedLookup) && parsedLookup > 0 ? parsedLookup : null;
      if (params?.mid) {
        this.disableFields = true;
        this.userId = params?.mid;
        this.merchantService.getMerchant(params?.mid).subscribe(async (res) => {
          this.getAllData = res.response.data;
          this.merchantLookupId = this.resolveLookupIdFromMerchant(this.getAllData) ?? this.merchantLookupId;
          this.merchantLicenseTypeLookupId = this.resolveLicenseTypeIdFromMerchant(this.getAllData);
          this.merchantBusinessActivityLookupId = this.resolveBusinessActivityIdFromMerchant(this.getAllData);
          // Reload options to ensure they're available before populating form
          await this.loadMerchantScopedDropdowns(
            this.merchantLookupId,
            this.merchantLicenseTypeLookupId,
            this.merchantBusinessActivityLookupId,
          );
          this.setFormValues(res.response.data);
        });
      } else {
        this.loadMerchantScopedDropdowns(this.merchantLookupId);
      }
    });

    this.form
      .get('phoneNumber')
      ?.valueChanges.pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(() => this.checkPhoneExists());

    this.form.get('firstName')?.valueChanges.subscribe(() => this.syncPrimaryShareholderIdentity());
    this.form.get('lastName')?.valueChanges.subscribe(() => this.syncPrimaryShareholderIdentity());

    this.form.get('userType')?.valueChanges.subscribe(() => this.onEntityTypeChange());
    this.form.get('merchantType')?.valueChanges.subscribe(() => this.applyMerchantTypeState());
    this.form.get('licenseType')?.valueChanges.subscribe(() => this.applyLicenseTypeState());
    this.form.get('activity')?.valueChanges.subscribe((activityId) => this.onActivityChange(activityId));
    this.regularGroup
      .get('numberOfShareholders')
      ?.valueChanges.pipe(debounceTime(300))
      .subscribe((count: number) => this.resizeShareholders(count));
    this.form
      .get('clientProLevel')
      ?.valueChanges.subscribe(() => this.applyClientProLevelState());

    this.applyMerchantTypeState();

    if (!(this.permissions.includes('Add') || this.permissions.includes('Edit'))) {
      this.form.disable();
    }
  }

  private resolveLookupIdFromMerchant(merchant: any): number | null {
    if (!merchant) return null;
    const candidates = [
      merchant?.bankCode,
      merchant?.bank_code,
      merchant?.bankId,
      merchant?.bank_id,
      merchant?.bankName,
      merchant?.id,
      merchant?.userId,
    ];
    for (const candidate of candidates) {
      const n = Number(candidate);
      if (Number.isFinite(n) && n > 0) return n;
    }
    return null;
  }

  private resolveLicenseTypeIdFromMerchant(merchant: any): number | null {
    const value = merchant?.licenseType;
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  private resolveBusinessActivityIdFromMerchant(merchant: any): number | null {
    const value = merchant?.businessActivity;
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  private async loadMerchantScopedDropdowns(
    id?: number | null,
    licenseTypeId?: number | null,
    businessActivityId?: number | null,
  ) {
    await this.getBusinessActivities(businessActivityId ?? id);
    this.merchantService.getLicenseTypes(licenseTypeId ?? id).subscribe((res: any) => {
      // licenseType is stored/submitted as the id, but as a string.
      this.licenseTypeOptions = (res?.response?.data || []).map((lt: any) => ({
        ...lt,
        id: String(lt.id),
      }));
    });
    this.merchantService.getBanks(id).subscribe((res: any) => {
      this.banksOptions = (res?.response?.data || []).map((vr: any) => ({
        ...vr,
        id: String(vr.id),
      }));
    });
  }

  private buildShareholderGroup(): FormGroup {
    const group = this.formBuilder.group({
      id: [''],
      firstName: [
        '',
        [
          Validators.required,
          moreThanOneWhiteSpaceValidator(),
          Validators.pattern(this.nameRegex),
          Validators.maxLength(50),
        ],
      ],
      lastName: [
        '',
        [
          Validators.required,
          moreThanOneWhiteSpaceValidator(),
          Validators.pattern(this.nameRegex),
          Validators.maxLength(50),
        ],
      ],
      birthDate: ['', Validators.required],
      documentExpirationDate: ['', Validators.required],
      documentId: ['', [Validators.required, Validators.maxLength(50)]],
      idCardType: ['CIN', Validators.required],
      cinFrontFile: [null, Validators.required],
      cinBackFile: [null],
      idCardFile: [null],
      uboPercentage: [''],
    });
    group.get('idCardType')?.valueChanges.subscribe(() => this.applyIdCardTypeValidators(group));
    return group;
  }

  private applyIdCardTypeValidators(group: FormGroup) {
    const idCardType = group.get('idCardType')?.value || 'CIN';
    const front = group.get('cinFrontFile');
    const back = group.get('cinBackFile');
    const single = group.get('idCardFile');
    const index = this.shareholders.controls.indexOf(group);

    if (idCardType === 'CIN') {
      front?.setValidators([Validators.required]);
      back?.clearValidators();
      single?.clearValidators();
      single?.setValue(null, { emitEvent: false });
      if (index > -1) delete this.uploadedFileNames[`shareholder_${index}_idCardFile`];
    } else {
      front?.clearValidators();
      front?.setValue(null, { emitEvent: false });
      back?.clearValidators();
      back?.setValue(null, { emitEvent: false });
      single?.setValidators([Validators.required]);
      if (index > -1) {
        delete this.uploadedFileNames[`shareholder_${index}_cinFrontFile`];
        delete this.uploadedFileNames[`shareholder_${index}_cinBackFile`];
      }
    }
    front?.updateValueAndValidity({ emitEvent: false });
    back?.updateValueAndValidity({ emitEvent: false });
    single?.updateValueAndValidity({ emitEvent: false });
  }

  private applyShareholderUboValidators() {
    const showUbo = this.shareholders.length > 1;
    this.shareholders.controls.forEach((group) => {
      const ubo = (group as FormGroup).get('uboPercentage');
      if (showUbo) {
        ubo?.setValidators([Validators.required, Validators.min(0), Validators.max(100)]);
      } else {
        ubo?.clearValidators();
        ubo?.setValue('', { emitEvent: false });
      }
      ubo?.updateValueAndValidity({ emitEvent: false });
    });
  }

  private resizeShareholders(count: number) {
    const n = Math.max(1, Math.floor(Number(count)) || 1);
    while (this.shareholders.length < n) {
      this.shareholders.push(this.buildShareholderGroup());
    }
    while (this.shareholders.length > n) {
      this.shareholders.removeAt(this.shareholders.length - 1);
    }
    this.syncPrimaryShareholderIdentity();
    this.applyShareholderUboValidators();
  }

  private syncPrimaryShareholderIdentity() {
    const primary = this.shareholders.at(0) as FormGroup;
    if (!primary) return;
    primary.get('firstName')?.setValue(this.form.get('firstName')?.value || '', { emitEvent: false });
    primary.get('lastName')?.setValue(this.form.get('lastName')?.value || '', { emitEvent: false });
  }

  onEntityTypeChange() {
    if (this.applyingEntityTypeState) {
      return;
    }

    this.applyingEntityTypeState = true;
    try {
      if (!this.isMerchantEntity) {
        this.form.get('merchantType')?.setValue(null, { emitEvent: false });
        this.form.get('licenseType')?.setValue(null, { emitEvent: false });
      } else if (!this.form.get('merchantType')?.value) {
        this.form.get('merchantType')?.setValue('REGULAR', { emitEvent: false });
      }
      this.applyMerchantTypeState();
    } finally {
      this.applyingEntityTypeState = false;
    }
  }

  private setRequired(controlName: string, required: boolean) {
    const c = this.form.get(controlName);
    c?.setValidators(required ? [Validators.required] : null);
    c?.updateValueAndValidity();
  }

  private applyMerchantTypeState() {
    // Prevent recursive calls
    if (this.applyingMerchantTypeState) {
      return;
    }

    this.applyingMerchantTypeState = true;
    try {
      const isMerchant = this.isMerchantEntity;
      const merchantType = this.form.get('merchantType')?.value;
      const isRegular = isMerchant && merchantType === 'REGULAR';
      const isClientPro = isMerchant && merchantType === 'CLIENT_PRO';

      this.setRequired('merchantType', isMerchant);
      this.setRequired('licenseType', isRegular);
      this.setRequired('clientProLevel', isClientPro);
      this.setRequired('bankName', isMerchant);

      if (!isRegular) {
        this.form.get('licenseType')?.setValue(null, { emitEvent: false });
      }

      if (!isClientPro) {
        this.form.get('clientProLevel')?.setValue(null, { emitEvent: false });
      }

      if (isRegular) {
        this.regularGroup.enable({ emitEvent: false });
        this.shareholders.enable({ emitEvent: false });
        this.applyLicenseTypeState();
      } else {
        this.regularGroup.disable({ emitEvent: false });
        this.shareholders.disable({ emitEvent: false });
      }

      if (isClientPro) {
        this.clientProGroup.enable({ emitEvent: false });
        this.applyClientProLevelState();
      } else {
        this.clientProGroup.disable({ emitEvent: false });
      }
    } finally {
      this.applyingMerchantTypeState = false;
    }
  }

  private applyLicenseTypeState() {
    // Prevent recursive calls
    if (this.applyingLicenseTypeState) {
      return;
    }

    this.applyingLicenseTypeState = true;
    try {
      const licenseType = this.form.get('licenseType')?.value;
      const g = this.regularGroup;

      // Preserve field values before clearing them
      const savedNumberOfShareholders = g.get('numberOfShareholders')?.value;
      const savedDocumentValues: { [key: string]: any } = {};
      const savedUploadedFileNames: { [key: string]: string | undefined } = {};
      this.regularDocumentKeys.forEach((key) => {
        savedDocumentValues[key] = g.get(key)?.value;
        savedUploadedFileNames[key] = this.uploadedFileNames[`regular_${key}`];
      });
      const enabledDocumentKeys = new Set<string>();

      const setField = (key: string, enabled: boolean, required = true) => {
        const c = g.get(key);
        if (enabled) {
          c?.enable({ emitEvent: false });
          c?.setValidators(required ? [Validators.required] : null);
          if (this.regularDocumentKeys.includes(key)) {
            enabledDocumentKeys.add(key);
          }
        } else {
          c?.disable({ emitEvent: false });
          c?.clearValidators();
          c?.setValue(null, { emitEvent: false });
          delete this.uploadedFileNames[`regular_${key}`];
        }
        c?.updateValueAndValidity({ emitEvent: false });
      };

      const allDocKeys = [
        'proofOfAddressFile',
        'selfEmployedCertFile',
        'taxDocumentFile',
        'rcDocumentFile',
        'interiorPhotoFile',
        'exteriorPhotoFile',
        'articlesOfAssociationFile',
        'numberOfShareholders',
      ];
      allDocKeys.forEach((key) => setField(key, false));

      if (licenseType === '1' || licenseType === '5' || licenseType === '9') {
        setField('proofOfAddressFile', true);
        setField('selfEmployedCertFile', true);
      } else if (licenseType === '2' || licenseType === '6' || licenseType === '10') {
        setField('taxDocumentFile', true);
        setField('interiorPhotoFile', true);
        setField('exteriorPhotoFile', true);
      } else if (licenseType === '3' || licenseType === '4'
        || licenseType === '7' || licenseType === '8'
      || licenseType === '11' || licenseType === '12' ) {
        setField('numberOfShareholders', true);
        // Restore the saved numberOfShareholders value instead of using current value (which was just cleared)
        g.get('numberOfShareholders')?.setValue(savedNumberOfShareholders || 1, { emitEvent: false });
        setField('rcDocumentFile', true, false);
        setField('taxDocumentFile', true);
        setField('interiorPhotoFile', true);
        setField('exteriorPhotoFile', true);
        setField('articlesOfAssociationFile', true, false);
      }

      enabledDocumentKeys.forEach((key) => {
        const savedValue = savedDocumentValues[key];
        if (!savedValue) {
          return;
        }
        g.get(key)?.setValue(savedValue, { emitEvent: false });
        this.uploadedFileNames[`regular_${key}`] = savedUploadedFileNames[key] || 'Previously uploaded';
      });

      if (licenseType === '3' || licenseType === '4'|| licenseType === '7' || licenseType === '8'
      || licenseType === '11' || licenseType === '12') {
        this.resizeShareholders(g.get('numberOfShareholders')?.value || 1);
      } else {
        this.resizeShareholders(1);
      }
    } finally {
      this.applyingLicenseTypeState = false;
    }
  }

  private applyClientProLevelState() {
    // Prevent recursive calls
    if (this.applyingClientProLevelState) {
      return;
    }

    this.applyingClientProLevelState = true;
    try {
      const level = this.form.get('clientProLevel')?.value;
      const interior = this.clientProGroup.get('interiorPhotoFile');
      const exterior = this.clientProGroup.get('exteriorPhotoFile');
      if (level === 'L2') {
        interior?.enable({ emitEvent: false });
        exterior?.enable({ emitEvent: false });
        interior?.setValidators([Validators.required]);
        exterior?.setValidators([Validators.required]);
      } else {
        interior?.disable({ emitEvent: false });
        exterior?.disable({ emitEvent: false });
        interior?.clearValidators();
        exterior?.clearValidators();
        interior?.setValue(null, { emitEvent: false });
        exterior?.setValue(null, { emitEvent: false });
        delete this.uploadedFileNames['clientPro_interiorPhotoFile'];
        delete this.uploadedFileNames['clientPro_exteriorPhotoFile'];
      }
      interior?.updateValueAndValidity({ emitEvent: false });
      exterior?.updateValueAndValidity({ emitEvent: false });
    } finally {
      this.applyingClientProLevelState = false;
    }
  }

  private refreshDynamicFormStateAfterHydration() {
    // Keep dynamic validator/enablement state aligned with hydrated edit values.
    this.applyMerchantTypeState();
    if (this.isRegularMerchant) {
      this.applyLicenseTypeState();
    }
    if (this.isClientPro) {
      this.applyClientProLevelState();
    }
    this.applyShareholderUboValidators();
    this.form.updateValueAndValidity({ emitEvent: false });
  }

  // ---- Field configs (data-driven sections; no nested *ngIf trees) ----

  get contactFieldConfigs(): FieldConfig[] {
    return [
      {
        key: 'phoneNumber', type: 'text', label: 'Phone Number', required: true,
        placeholder: 'Phone Number', maxlength: 10,
        keypress: (e: any) => this.OnlyNumbersAllowed(e),
      },
      { key: 'firstName', type: 'text', label: 'First Name', required: true, maxlength: 50 },
      { key: 'lastName', type: 'text', label: 'Last Name', required: true, maxlength: 50 },
      {
        key: 'userType', type: 'select', label: 'Entity Type', required: true,
        items: this.entityTypeOptions, bindLabel: 'text', bindValue: 'value',
        readonly: this.disableFields,
      },
      { key: 'emailId', type: 'text', label: 'Email Id', placeholder: 'sample@Global.in', maxlength: 50 },
      { key: 'address', type: 'text', label: 'Address', required: true, maxlength: 200 },
      { key: 'city', type: 'text', label: 'City', required: false, maxlength: 50 },
    ];
  }

  get transactionLimitDisplay(): string {
    const level = this.form.get('clientProLevel')?.value;
    if (!level) return '';
    return level === 'L2' ? 'DH 4,000' : 'DH 1,000';
  }

  get merchantCommonFieldConfigs(): FieldConfig[] {
    const fields: FieldConfig[] = [
      {
        key: 'merchantType', type: 'select', label: 'Merchant Type', required: true,
        items: this.merchantTypeOptions, bindLabel: 'text', bindValue: 'value',
        readonly: this.disableFields,
      },
    ];
    if (this.isClientPro) {
      fields.push({
        key: 'clientProLevel', type: 'select', label: 'Client Pro Level', required: true,
        items: this.clientProLevelOptions, bindLabel: 'text', bindValue: 'value',
      });
    }
    if (!this.isClientPro) {
      fields.push({
        key: 'licenseType', type: 'select', label: 'License Type', required: true,
        items: this.licenseTypeOptions, bindLabel: 'name', bindValue: 'id',
      });
      fields.push({
        key: 'companyName', type: 'text', label: 'Company Name', maxlength: 200,
        hidden: !['4', '8', '12'].includes(String(this.form.get('licenseType')?.value)),
      });
    }
    fields.push(
      {
        key: 'businessCategory', type: 'select', label: 'Business Category', required: true,
        items: this.categoryTypeOptions, bindLabel: 'bussinessCategories', bindValue: 'id',
        onChange: (e: any) => this.onselectBusinessCat(e), hidden: true,
      },
      {
        key: 'businessSubCategory', type: 'select', label: 'Business SubCategory', required: false,
        items: this.subCategoryTypeOptions, bindLabel: 'displayName', bindValue: 'id',
        onChange: (e: any) => this.onselectBusinessSubCat(e), hidden: true,
      },
      {
        key: 'businessActivity', type: 'select', label: 'Business Activity', required: false,
        items: this.businessActivityOptions, bindLabel: 'activityName', bindValue: 'id',
      },
      {
        key: 'activity', type: 'select', label: 'Activity', required: false,
        items: this.activityOptions, bindLabel: 'brancheLabel', bindValue: 'id',
      },
      {
        key: 'subActivity', type: 'select', label: 'Sub Activity', required: false,
        items: this.subActivityOptions, bindLabel: 'label', bindValue: 'id',
      },
      {
        key: 'volumeRange', type: 'select', label: 'Volume Yearly Range',
        items: this.volumeYearlyRangeOptions, bindLabel: 'name', bindValue: 'id',
      },
      {
        key: 'bankName', type: 'select', label: 'Bank Name',
        items: this.banksOptions, bindLabel: 'name', bindValue: 'id',
      },
      { key: 'iban', type: 'text', label: 'RIB', required: false, maxlength: 200 },
      {
        key: 'pgInstruments', type: 'select', label: 'Payment Type', required: false,
        items: this.instrumentMasterOptions, bindLabel: 'FieldText',
        multiple: true, closeOnSelect: false, searchable: false,
      },
    );
    return fields;
  }

  get merchantContractFieldConfigs(): FieldConfig[] {
    return [
      {
        key: 'signedContractFile', type: 'file', label: 'Signed Contract', required: false,
        accept: '.docx,.pdf,.png,.jpg,.jpeg,.bmp', documentType: 'MERCHANT_SIGN',
        extensions: this.allowedDocExtensions, uploadedFileKey: 'signedContractFile',
      },
      {
        key: 'pay10ContractSignedFile', type: 'file', label: 'Pay10 Contract Signed', required: false,
        accept: '.docx,.pdf,.png,.jpg,.jpeg,.bmp', documentType: 'SIGNED_CONTRACT',
        extensions: this.allowedDocExtensions, uploadedFileKey: 'pay10ContractSignedFile',
      },
    ];
  }

  get licenseDocFieldConfigs(): FieldConfig[] {
    const licenseType = this.form.get('licenseType')?.value;
    const docField = (key: string, label: string, isPhoto = false, required = true): FieldConfig => ({
      key,
      type: 'file',
      label,
      required,
      accept: isPhoto ? '.png,.jpg,.jpeg' : '.pdf,.png,.jpg,.jpeg,.bmp',
      documentType: this.licenseDocumentTypeMap[licenseType]?.[key],
      extensions: isPhoto ? this.allowedPhotoExtensions : this.allowedDocExtensions,
      uploadedFileKey: `regular_${key}`,
    });

    if (licenseType === '1' || licenseType === '5' || licenseType === '9') {
      return [
        docField('proofOfAddressFile', 'Proof of Address'),
        docField('selfEmployedCertFile', 'Self-employed Registration Certificate'),
      ];
    }
    if (licenseType === '2' || licenseType === '6' || licenseType === '10') {
      return [
        docField('taxDocumentFile', 'Tax Document'),
        docField('interiorPhotoFile', 'Interior Photo', true),
        docField('exteriorPhotoFile', 'Exterior Photo', true),
      ];
    }
    if (licenseType === '3' || licenseType === '4' || licenseType === '7' || licenseType === '8'
    || licenseType === '11' || licenseType === '12') {
      return [
        {
          key: 'numberOfShareholders', type: 'number', label: 'Number of Shareholders', required: true,
        },
        docField('rcDocumentFile', 'Document RC (moins de 3 mois)', false, false),
        docField('taxDocumentFile', 'Tax Document'),
        docField('interiorPhotoFile', 'Interior Photo', true),
        docField('exteriorPhotoFile', 'Exterior Photo', true),
        docField('articlesOfAssociationFile', 'Articles of Association', false, false),
      ];
    }
    return [];
  }

  shareholderFieldConfigs(index: number): FieldConfig[] {
    const todayStr = new Date().toISOString().slice(0, 10);
    const idCardType = this.getShareholderGroup(index)?.get('idCardType')?.value || 'CIN';
    const fields: FieldConfig[] = [
      {
        key: 'birthDate', type: 'date', label: 'Birth Date', required: true,
        max: todayStr, preventKeyInput: true,
      },
      {
        key: 'firstName', type: 'text', label: 'First Name', required: true, maxlength: 50,
        readonly: index === 0,
      },
      {
        key: 'lastName', type: 'text', label: 'Last Name', required: true, maxlength: 50,
        readonly: index === 0,
      },
      {
        key: 'documentExpirationDate', type: 'date', label: 'Document Expiration Date', required: true,
        min: todayStr, preventKeyInput: true,
      },
      {
        key: 'idCardType', type: 'select', label: 'Document ID Type', required: true,
        items: this.idCardTypeOptions, bindLabel: 'text', bindValue: 'value',
      },
      { key: 'documentId', type: 'text', label: 'Document ID', required: true, maxlength: 50 },
    ];

    if (idCardType === 'CIN') {
      fields.push(
        {
          key: 'cinFrontFile', type: 'file', label: 'CIN Front', required: true,
          accept: '.pdf,.png,.jpg,.jpeg,.bmp', documentType: 'NATIONAL_ID_FRONT',
          extensions: this.allowedDocExtensions, uploadedFileKey: `shareholder_${index}_cinFrontFile`,
        },
        {
          key: 'cinBackFile', type: 'file', label: 'CIN Back', required: false,
          accept: '.pdf,.png,.jpg,.jpeg,.bmp', documentType: 'NATIONAL_ID_BACK',
          extensions: this.allowedDocExtensions, uploadedFileKey: `shareholder_${index}_cinBackFile`,
        },
      );
    } else {
      fields.push({
        key: 'idCardFile', type: 'file',
        label: idCardType === 'PASSPORT' ? 'Passport' : 'Residence Permit',
        required: true, accept: '.pdf,.png,.jpg,.jpeg,.bmp',
        documentType: idCardType,
        extensions: this.allowedDocExtensions, uploadedFileKey: `shareholder_${index}_idCardFile`,
      });
    }

    if (this.shareholders.length > 1) {
      fields.push({ key: 'uboPercentage', type: 'percentage', label: 'UBO Percentage', required: true });
    }
    return fields;
  }

  get clientProLocationFieldConfigs(): FieldConfig[] {
    return [
      { key: 'latitude', type: 'text', label: 'Latitude', required: true, placeholder: 'e.g. 33.5731' },
      { key: 'longitude', type: 'text', label: 'Longitude', required: true, placeholder: 'e.g. -7.5898' },
    ];
  }

  get clientProPhotoFieldConfigs(): FieldConfig[] {
    if (this.form.get('clientProLevel')?.value !== 'L2') return [];
    return [
      {
        key: 'interiorPhotoFile', type: 'file', label: 'Interior Photo', required: true,
        accept: '.png,.jpg,.jpeg', documentType: 'INDOOR_PHOTO',
        extensions: this.allowedPhotoExtensions, uploadedFileKey: 'clientPro_interiorPhotoFile',
      },
      {
        key: 'exteriorPhotoFile', type: 'file', label: 'Exterior Photo', required: true,
        accept: '.png,.jpg,.jpeg', documentType: 'OUTDOOR_PHOTO',
        extensions: this.allowedPhotoExtensions, uploadedFileKey: 'clientPro_exteriorPhotoFile',
      },
    ];
  }

  // ---- File upload (reuses the working upload endpoint/shape) ----

  private pickValidFile(event: any, allowedExtensions: string[]): File | null {
    const file = event?.target?.files?.[0];
    if (!file) return null;
    const ext = file.name?.split('.').pop() || '';
    if (!allowedExtensions.includes(ext)) {
      this.alertService.errorAlert({
        html: 'Only PDF, PNG, JPG, JPEG, BMP files are allowed',
      });
      return null;
    }
    return file;
  }

  private uploadDocument(
    event: any,
    group: FormGroup,
    controlKey: string,
    documentType: string,
    allowedExtensions: string[],
    displayKey: string,
  ) {
    const file = this.pickValidFile(event, allowedExtensions);
    event.target.value = '';
    if (!file) return;

    const mobileNumber = this.form.get('phoneNumber')?.value;
    const control = group.get(controlKey);
    control?.setValue(null);
    delete this.uploadedFileNames[displayKey];

    const formData = new FormData();
    formData.append('mobileNumber', mobileNumber);
    formData.append('documentType', documentType);
    formData.append('document', file);

    this.merchantService.uploadNewMerchantDocument(formData).subscribe({
      next: (res: any) => {
        if (res?.response?.status == 200) {
          control?.setValue(res?.response?.data || file.name);
          this.uploadedFileNames[displayKey] = file.name;
        } else {
          this.alertService.errorAlert({
            html: `Failed to upload ${documentType.replace(/_/g, ' ')}. Please try again.`,
          });
        }
      },
      error: () => {
        this.alertService.errorAlert({
          html: `Failed to upload ${documentType.replace(/_/g, ' ')}. Please try again.`,
        });
      },
    });
  }

  onFieldFileChange(event: any, group: FormGroup, field: FieldConfig) {
    this.uploadDocument(
      event,
      group,
      field.key,
      field.documentType || field.key,
      field.extensions || this.allowedDocExtensions,
      field.uploadedFileKey || field.key,
    );
  }

  onFieldFileView(group: FormGroup, field: FieldConfig) {
    const path = group.get(field.key)?.value;
    this.viewDocument(path, field.label);
  }

  onFieldFileRemove(group: FormGroup, field: FieldConfig) {
    group.get(field.key)?.setValue(null);
    delete this.uploadedFileNames[field.uploadedFileKey || field.key];
  }

  private viewDocument(path: string, title: string) {
    if (!path) return;
    this.http
      .get(`${API_URLBLAZE}/user/files/download`, {
        params: { path },
        responseType: 'blob',
        observe: 'response',
      })
      .subscribe({
        next: (response) => {
          const serverType = response.headers.get('Content-Type') ?? '';
          const ext = path.split('.').pop()?.toLowerCase() ?? '';
          const contentType =
              serverType &&
              !serverType.toLowerCase().startsWith('application/octet-stream')
                ? serverType
                : MIME_BY_EXT[ext] ?? 'application/pdf';

          const blob = new Blob([response.body!], { type: contentType });
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const modalRef = this.modalService.open(DocumentViewerModalComponent, {
              size: 'xl',
              centered: true,
            });
            modalRef.componentInstance.dataUrl = reader.result as string;
            modalRef.componentInstance.title = title;
            modalRef.componentInstance.isImage = contentType.startsWith('image/');
            modalRef.componentInstance.contentType = contentType;
          };
        },
        error: () => {
          this.alertService.errorAlert({ html: `Unable to load ${title}. Please try again.` });
        },
      });
  }

  // ---- Business category / subcategory (unchanged risk-code lookup) ----

  getBusinessCatigory() {
    this.merchantService.getCategoryType().subscribe((data) => {
      this.categoryTypeOptions = data;
    });
  }

  async getBusinessActivities(id?: number | null) {
    try {
      const res = await lastValueFrom(this.merchantService.getBusinessActivities(id));
      const data = res?.response?.data || res?.data || res || [];
      this.businessActivityOptions = Array.isArray(data) ? data.map((ba: any) => ({
        ...ba,
        id: String(ba.id),
      })) : [];
      console.log('Business Activities loaded:', this.businessActivityOptions);
    } catch (error) {
      console.error('Error loading business activities:', error);
      this.businessActivityOptions = [];
    }
  }

  loadActivityDropdown() {
    this.merchantService.getActivities().subscribe({
      next: (res: any) => {
        const raw: any[] = res?.response?.data || res?.data || res || [];
        this.activityOptions = raw.map((a: any) => ({ ...a, id: String(a.id) }));
      },
      error: () => { this.activityOptions = []; },
    });
  }

  onActivityChange(activityId: any) {
    if (this.hydratingFromServer) return;
    this.subActivityOptions.splice(0);
    this.form.get('subActivity')?.setValue(null, { emitEvent: false });
    if (!activityId) return;
    this.merchantService.getSubActivitiesByActivity(activityId).subscribe({
      next: (res: any) => {
        const raw: any[] = res?.response?.data || res?.data || res || [];
        this.subActivityOptions = raw.map((a: any) => ({ ...a, id: String(a.id) }));
      },
      error: () => { this.subActivityOptions.splice(0); },
    });
  }

  onselectBusinessCat(event: any) {
    this.business_category = event?.id || event;
    this.getBusinessSubCatigory(this.business_category);
  }

  onselectBusinessSubCat(event: any) {
    if (event != undefined) {
      this.riskLevelCode1 = [event];
      this.riskLevelCode = event.riskLevelCode;
      this.business_subCategory = event.id;
    } else {
      this.riskLevelCode = '';
      this.riskLevelCode1 = [];
    }
  }

  getBusinessSubCatigory(valevent: any) {
    if (!valevent) return;
    this.merchantService.getSubCategoryType(valevent).subscribe((data) => {
      this.subCategoryTypeOptions = data;
      (this.subCategoryTypeOptions || []).forEach((it: any) => {
        const name = it?.bussinessSubCategories || '';
        const mcc = it?.mccCode || '';
        it.displayName = mcc ? `${name} - ${mcc}` : name;
      });

      if (this.getAllData && this.getAllData.business_subCategory) {
        const selected = this.subCategoryTypeOptions.find(
          (subCat) => subCat.id === Number(this.getAllData.business_subCategory),
        );
        if (selected) {
          this.riskLevelCode = (selected as any).riskLevelCode;
          this.riskLevelCode1 = [selected];
        }
      }
    });
  }

  // ---- Misc input helpers ----

  noKeyInput(_$event: any) {
    return false;
  }

  OnlyNumbersAllowed(event: { which: any; keyCode: any }): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return charCode > 47 && charCode < 58;
  }

  OnlyCharacterAllowed(event: { which: any; keyCode: any }): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return (
      (charCode >= 65 && charCode <= 90) ||
      (charCode >= 97 && charCode <= 122) ||
      charCode == 32
    );
  }

  // ---- Submit ----

  private phoneExistsCheck$() {
    const phone = this.form.get('phoneNumber')?.value;
    const contactUrl = this.userId
      ? `${API_URLBLAZE}/user/check-mobile/${phone}/${this.userId}`
      : `${API_URLBLAZE}/user/check-mobile/${phone}`;
    return this.apiHttpService.get(contactUrl).pipe(
      timeout(8000),
      catchError(() => of(null)),
    );
  }

  checkPhoneExists() {
    const phoneCtrl = this.form.get('phoneNumber');
    if (!phoneCtrl?.value || phoneCtrl.invalid) {
      this.phoneExists = false;
      this.phoneError = '';
      return;
    }

    this.checkingPhone = true;
    this.phoneExistsCheck$().subscribe({
      next: (contactData: any) => {
        this.checkingPhone = false;
        this.phoneExists = !!contactData?.response?.data;
        this.phoneError = this.phoneExists ? 'This Contact Number already exists!' : '';
      },
      error: () => {
        this.checkingPhone = false;
      },
    });
  }

  requestPosEnable(): void {
    if (!this.userId) {
      this.alertService.errorAlert({ text: 'Merchant ID is missing.' });
      return;
    }

    this.posEnableLoading = true;
    this.merchantService.sendPOSRequest(this.userId).subscribe({
      next: (response: any) => {
        this.posEnableLoading = false;
        if (response?.response?.status == 200 || response?.status == 200) {
          this.posEnable = true;
          this.alertService.successAlert(response?.response?.message || 'POS device enabled successfully.');
        } else {
          this.alertService.errorAlert({ text: response?.response?.message || 'Unable to enable POS device.' });
        }
      },
      error: () => {
        this.posEnableLoading = false;
        this.alertService.errorAlert({ text: 'Unable to enable POS device.' });
      },
    });
  }

  onSubmit() {
    this.isSubmitted = true;
    const shareholdersValid = this.validateShareholderAges();
    if (this.form.invalid || !shareholdersValid) {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
      return;
    }

    this.checkingPhone = true;
    this.phoneExistsCheck$().subscribe({
      next: (contactData: any) => {
        this.checkingPhone = false;
        this.phoneExists = !!contactData?.response?.data;
        if (this.phoneExists) {
          this.phoneError = 'This Contact Number already exists!';
          window.scroll({ top: 0, left: 0, behavior: 'smooth' });
          return;
        }
        this.phoneError = '';
        this.submitMerchant();
      },
      error: () => {
        this.checkingPhone = false;
      },
    });
  }

  private toDdMmYyyy(isoDate: string): string {
    if (!isoDate) return '';
    const [y, m, d] = isoDate.split('-');
    if (!y || !m || !d) return '';
    return `${d}/${m}/${y}`;
  }

  private submitMerchant() {
    this.loading = true;
    const merchantObj = this.buildMerchantObj();
    const primaryShareholder = this.shareholders.at(0)?.value || {};
    this.merchantService.createMerchant(merchantObj).subscribe((response: any) => {
      this.loading = false;
      if (response?.response?.status == 200) {
        this.alertService.successAlert(response.response.message, '');
        const data = response.response.data || {};
        if(data.oboardedOn!='APP' && data.status === 'NEW'){
        this.router.navigate(['/merchants/merchant-creation/wallet-registration'], {
          queryParams: { ...this.queryParams, mid: data.userId, identifier: data.identifier },
          state: {
            encKey: data.encKey || '',
            mobileNumber: this.form.get('phoneNumber')?.value || '',
            firstName: this.form.get('firstName')?.value || '',
            lastName: this.form.get('lastName')?.value || '',
            nationalId: primaryShareholder.documentId || '',
            expirationDate: this.toDdMmYyyy(primaryShareholder.documentExpirationDate),
            userType: (this.form.get('userType')?.value || '').toUpperCase(),
          },
        });
      }
      } else {
        this.alertService.errorAlert({ text: 'Error while onboarding User.!' });
      }
    });
  }

  private buildMerchantObj(): any {
    const v = this.form.getRawValue();
    const isMerchant = this.isMerchantEntity;
    const isRegular = isMerchant && v.merchantType === 'REGULAR';
    const isClientPro = isMerchant && v.merchantType === 'CLIENT_PRO';

    const shareholderList = v.shareholders || [];
    const multipleShareholders = isRegular && shareholderList.length > 1;

    type DocInfo = { documentType: string; documentPath: string; status?: string };
    const originalTopDocs: DocInfo[] = this.getAllData?.documentInfos || [];
    const originalShareholders: any[] = this.getAllData?.shareholders || [];
    const withStatus = (documentType: string, documentPath: string, originalDocs: DocInfo[]): DocInfo => {
      const original = originalDocs.find((d) => d.documentType === documentType && d.documentPath === documentPath);
      return original?.status ? { documentType, documentPath, status: original.status } : { documentType, documentPath };
    };

    const shareholderDocs = (sh: any, originalDocs: DocInfo[]): DocInfo[] => {
      const docs: DocInfo[] = [];
      if (sh.idCardType === 'CIN' || !sh.idCardType) {
        if (sh.cinFrontFile) docs.push(withStatus('NATIONAL_ID_FRONT', sh.cinFrontFile, originalDocs));
        if (sh.cinBackFile) docs.push(withStatus('NATIONAL_ID_BACK', sh.cinBackFile, originalDocs));
      } else if (sh.idCardFile) {
        docs.push(withStatus(sh.idCardType, sh.idCardFile, originalDocs));
      }
      return docs;
    };

    const documentInfos: DocInfo[] = [];
    if (isRegular) {
      const docTypeMap = this.licenseDocumentTypeMap[v.licenseType] || {};
      Object.entries(docTypeMap).forEach(([key, docType]) => {
        const path = v.regular?.[key];
        if (path) documentInfos.push(withStatus(docType, path, originalTopDocs));
      });
      if (!multipleShareholders) {
        shareholderList.forEach((sh: any) => documentInfos.push(...shareholderDocs(sh, originalTopDocs)));
      }
    }
    if (isMerchant) {
      if (v.signedContractFile) {
        documentInfos.push(withStatus('SIGNED_CONTRACT', v.signedContractFile, originalTopDocs));
      }
      if (v.pay10ContractSignedFile) {
        documentInfos.push(withStatus('PAY10_CONTRACT_SIGNED', v.pay10ContractSignedFile, originalTopDocs));
      }
    }
    if (isClientPro) {
      if (v.clientPro?.interiorPhotoFile) {
        documentInfos.push(withStatus('INDOOR_PHOTO', v.clientPro.interiorPhotoFile, originalTopDocs));
      }
      if (v.clientPro?.exteriorPhotoFile) {
        documentInfos.push(withStatus('OUTDOOR_PHOTO', v.clientPro.exteriorPhotoFile, originalTopDocs));
      }
    }

    return {
      userId: this.userId || '',
      contactNumber: v.phoneNumber || '',
      firstName: v.firstName || '',
      lastName: v.lastName || '',
      emailId: v.emailId || '',
      maker_checker: 'N',
      source: 'Admin',
      userType: v.userType || '',
      merchantType: isMerchant ? v.merchantType || '' : '',
      licenseType: isMerchant ? v.licenseType || '' : '',
      companyName: isMerchant ? v.companyName || '' : '',
      businessActivity: isMerchant ? v.businessActivity || '' : '',
      activity: isMerchant ? v.activity || '' : '',
      subActivity: isMerchant ? v.subActivity || '' : '',
      volumeRange: isMerchant ? v.volumeRange || '' : '',
      bankName: isMerchant ? v.bankName || '' : '',
      iban: isMerchant ? v.iban || '' : '',
      instruments: isMerchant
        ? (v.pgInstruments || []).map((d: DropDownValues) => d.FieldValue).join(',')
        : '',
      riskwithsubact: this.riskLevelCode1,
      address: v.address || '',
      city: v.city || '',
      numberOfShareholders:
        isRegular && (v.licenseType === '3' || v.licenseType === '4'
          || v.licenseType === '7' || v.licenseType === '8'
    || v.licenseType === '11' || v.licenseType === '12')
          ? Number(v.regular?.numberOfShareholders) || 1
          : '',
      shareholders: isRegular
        ? shareholderList.map((sh: any, idx: number) => ({
            id: sh.id || '',
            firstName: sh.firstName || '',
            lastName: sh.lastName || '',
            dateOfBirth: sh.birthDate || '',
            idCardType: sh.idCardType || 'CIN',
            idCardNumber: sh.documentId || '',
            idCardExpiryDate: sh.documentExpirationDate || '',
            uboPercentage: sh.uboPercentage != null ? String(sh.uboPercentage) : '',
            documentInfos: multipleShareholders
              ? shareholderDocs(sh, originalShareholders[idx]?.documentInfos || [])
              : [],
          }))
        : [],
      clientProLevel: isClientPro ? v.clientProLevel || '' : '',
      transactionLimit: isClientPro ? this.transactionLimit : '',
      latitude: isClientPro ? v.clientPro?.latitude || '' : '',
      longitude: isClientPro ? v.clientPro?.longitude || '' : '',
      documentInfos,
    };
  }

  private setFormValues(data: any) {
    const v = Array.isArray(data) ? data[0] : data || {};


    this.phoneExists = false;
    this.phoneError = '';
    this.checkingPhone = false;

    this.business_category = Number(v?.business_category) || null;
    this.business_subCategory = Number(v?.business_subCategory) || null;
    this.riskLevelCode = v?.riskwithsubact?.[0]?.riskLevelCode ?? 'N/A';
    this.posEnable = [true, 'true', 1, '1'].includes(v?.posEnable);
    this.riskLevelCode1 = v?.riskwithsubact || [];
    this.getBusinessSubCatigory(v?.business_category);

    const patchAndHydrate = () => {
      this.form.patchValue(
        {
          phoneNumber: v?.contactNumber,
          firstName: v?.firstName,
          lastName: v?.lastName,
          emailId: v?.emailId,
          userType: v?.userType,
          merchantType: v?.merchantType || 'REGULAR',
          licenseType: v?.licenseType != null ? String(v.licenseType) : v?.licenseType,
          companyName: v?.companyName || '',
          businessActivity: v?.businessActivity != null ? String(v.businessActivity) : v?.businessActivity,
          activity: v?.activity != null ? String(v.activity) : v?.activity,
          subActivity: v?.subActivity != null ? String(v.subActivity) : v?.subActivity,
          volumeRange: v?.volumeRange != null ? String(v.volumeRange) : v?.volumeRange,
          bankName: v?.bankName,
          iban: v?.iban,
          pgInstruments:
            v?.instruments && v.instruments !== ''
              ? v.instruments
                  .split(',')
                  .map((val: any) => this.instrumentMasterOptions.find((opt) => opt.FieldValue == val))
                  .filter((opt: any) => !!opt)
              : [],
          address: v?.address,
          city: v?.city,
        },
        { emitEvent: false },
      );

      this.regularGroup.patchValue(
        {
          numberOfShareholders: v?.numberOfShareholders || 1,
        },
        { emitEvent: false },
      );

      this.clientProGroup.patchValue(
        {
          latitude: v?.latitude,
          longitude: v?.longitude,
          clientProLevel: v?.clientProLevel,
        },
        { emitEvent: false },
      );
      this.applyMerchantTypeState();
      this.applyLicenseTypeState();
      this.applyClientProLevelState();

      const existingDocs: { documentType: string; documentPath: string }[] = v?.documentInfos || [];
      const signedContract = existingDocs.find((d) => d.documentType === 'SIGNED_CONTRACT');
      const pay10Contract = existingDocs.find((d) => d.documentType === 'PAY10_CONTRACT_SIGNED');
      if (signedContract?.documentPath) {
        this.form.get('signedContractFile')?.setValue(signedContract.documentPath, { emitEvent: false });
        this.uploadedFileNames.signedContractFile = 'Previously uploaded';
      }
      if (pay10Contract?.documentPath) {
        this.form.get('pay10ContractSignedFile')?.setValue(pay10Contract.documentPath, { emitEvent: false });
        this.uploadedFileNames.pay10ContractSignedFile = 'Previously uploaded';
      }

      const regularDocTypeMap = this.licenseDocumentTypeMap[v?.licenseType] || {};
      Object.entries(regularDocTypeMap).forEach(([key, docType]) => {
        const existing = existingDocs.find((d) => d.documentType === docType);
        if (existing?.documentPath) {
          this.regularGroup.get(key)?.setValue(existing.documentPath, { emitEvent: false });
          this.uploadedFileNames[`regular_${key}`] = 'Previously uploaded';
        }
      });

      const shareholderData: any[] = v?.shareholders?.length
        ? v.shareholders
        : [
            {
              firstName: v?.firstName,
              lastName: v?.lastName,
              dateOfBirth: v?.dateOfBirth,
              idCardType: v?.legalIdType || 'CIN',
              idCardNumber: v?.legalId,
              idCardExpiryDate: v?.legalIdExpiryDate,
              uboPercentage: '',
            },
          ];
      if (shareholderData.length) {
        this.shareholders.clear();
        const multipleShareholders = shareholderData.length > 1;
        shareholderData.forEach((sh: any, idx: number) => {
          const group = this.buildShareholderGroup();
          group.patchValue(
            {
              id: sh.id || '',
              firstName: sh.firstName,
              lastName: sh.lastName,
              birthDate: sh.dateOfBirth,
              documentExpirationDate: sh.idCardExpiryDate,
              documentId: sh.idCardNumber,
              idCardType: sh.idCardType || 'CIN',
              uboPercentage: sh.uboPercentage ?? '',
            },
            { emitEvent: false },
          );
          this.applyIdCardTypeValidators(group);

          const scopedDocs: { documentType: string; documentPath: string }[] =
            multipleShareholders ? sh.documentInfos || [] : existingDocs;
          const front = scopedDocs.find((d) => d.documentType === 'NATIONAL_ID_FRONT');
          const back = scopedDocs.find((d) => d.documentType === 'NATIONAL_ID_BACK');
          const idCardDoc = scopedDocs.find((d) => d.documentType === sh.idCardType);
          if (front?.documentPath) {
            group.get('cinFrontFile')?.setValue(front.documentPath, { emitEvent: false });
            this.uploadedFileNames[`shareholder_${idx}_cinFrontFile`] = 'Previously uploaded';
          }
          if (back?.documentPath) {
            group.get('cinBackFile')?.setValue(back.documentPath, { emitEvent: false });
            this.uploadedFileNames[`shareholder_${idx}_cinBackFile`] = 'Previously uploaded';
          }
          if (idCardDoc?.documentPath) {
            group.get('idCardFile')?.setValue(idCardDoc.documentPath, { emitEvent: false });
            this.uploadedFileNames[`shareholder_${idx}_idCardFile`] = 'Previously uploaded';
          }
          this.shareholders.push(group);
        });
        // Shareholder #1 always mirrors the top-level contact name (readonly in the UI) -
        // re-enforce that after rebuilding the array, since the backend may return
        // null/stale names for shareholders[0] itself.
        this.syncPrimaryShareholderIdentity();
      }

      const interior = existingDocs.find((d) => d.documentType === 'INDOOR_PHOTO');
      const exterior = existingDocs.find((d) => d.documentType === 'OUTDOOR_PHOTO');
      if (v?.merchantType === 'CLIENT_PRO') {
        if (interior?.documentPath) {
          this.clientProGroup.get('interiorPhotoFile')?.setValue(interior.documentPath, { emitEvent: false });
          this.uploadedFileNames['clientPro_interiorPhotoFile'] = 'Previously uploaded';
        }
        if (exterior?.documentPath) {
          this.clientProGroup.get('exteriorPhotoFile')?.setValue(exterior.documentPath, { emitEvent: false });
          this.uploadedFileNames['clientPro_exteriorPhotoFile'] = 'Previously uploaded';
        }
      } else {
        if (interior?.documentPath) {
          this.regularGroup.get('interiorPhotoFile')?.setValue(interior.documentPath, { emitEvent: false });
          this.uploadedFileNames['regular_interiorPhotoFile'] = 'Previously uploaded';
        }
        if (exterior?.documentPath) {
          this.regularGroup.get('exteriorPhotoFile')?.setValue(exterior.documentPath, { emitEvent: false });
          this.uploadedFileNames['regular_exteriorPhotoFile'] = 'Previously uploaded';
        }
      }

      if (!(this.permissions.includes('Add') || this.permissions.includes('Edit'))) {
        this.form.disable();
      }

      this.refreshDynamicFormStateAfterHydration();
    };

    // Sub-activities must be in the options list before patchAndHydrate sets the
    // subActivity value, otherwise ng-select cannot match the saved id.
    // hydratingFromServer prevents the activity valueChanges listener from clearing
    // subActivityOptions and resetting subActivity while we're populating from server data.
    if (v?.activity) {
      this.merchantService.getSubActivitiesByActivity(v.activity).subscribe({
        next: (res: any) => {
          const raw: any[] = res?.response?.data || res?.data || res || [];
          this.subActivityOptions.splice(0, this.subActivityOptions.length, ...raw.map((a: any) => ({ ...a, id: String(a.id) })));
          console.log('[HYDRATE] subActivityOptions loaded:', this.subActivityOptions.length, 'items');
          console.log('[HYDRATE] subActivity to patch:', String(v.subActivity));
          console.log('[HYDRATE] matching option:', this.subActivityOptions.find(o => o.id === String(v.subActivity)));
          this.hydratingFromServer = true;
          patchAndHydrate();
          this.hydratingFromServer = false;
          console.log('[HYDRATE] subActivity control value after patch:', this.form.get('subActivity')?.value);
        },
        error: (err: any) => {
          console.error('[HYDRATE] getSubActivitiesByActivity error:', err);
          this.subActivityOptions.splice(0);
          this.hydratingFromServer = true;
          patchAndHydrate();
          this.hydratingFromServer = false;
        },
      });
    } else {
      this.hydratingFromServer = true;
      patchAndHydrate();
      this.hydratingFromServer = false;
    }
  }
  private validateShareholderAges(): boolean {
  const shareholders = this.form.get('shareholders') as FormArray;

  if (!shareholders) {
    return true;
  }

  let isValid = true;
  const today = new Date();

  shareholders.controls.forEach((shareholder) => {
    const birthDateControl = shareholder.get('birthDate');

    if (!birthDateControl || !birthDateControl.value) {
      return;
    }

    const birthDate = new Date(birthDateControl.value);

    let age = today.getFullYear() - birthDate.getFullYear();

    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    if (age < 18) {
      birthDateControl.setErrors({
        ...birthDateControl.errors,
        under18: true
      });

      isValid = false;
    } else {
      // Remove only the under18 error, keeping other errors
      const errors = birthDateControl.errors;

      if (errors) {
        delete errors['under18'];
        birthDateControl.setErrors(
          Object.keys(errors).length ? errors : null
        );
      }
    }
  });

  return isValid;
}
}
